import Budgets from '@/views/achat/budget/pages/Budget';
import Create from '@/views/achat/budget/pages/BudgetCreate';
import Edit from '@/views/achat/budget/pages/BudgetEdit';
import Show from '@/views/achat/budget/pages/BudgetShow';

export default [
  {
    path: '/achat/budget',
    name: 'budget',
    component: Budgets,
    meta: {
      auth: true,
      module: 'achat',
      permission: 'access setting',
    },
  },
  {
    path: '/achat/budget/create/:cloneId?',
    name: 'budget-create',
    component: Create,
    meta: {
      auth: true,
      module: 'achat',
      permission: 'access setting',
    },
  },
  {
    path: '/achat/budget/edit/:id',
    name: 'budget-edit',
    component: Edit,
    meta: {
      auth: true,
      module: 'achat',
      permission: 'access setting',
    },
  },
  {
    path: '/achat/budget/show/:id',
    name: 'budget-show',
    component: Show,
    meta: {
      auth: true,
      module: 'achat',
      permission: 'access setting',
    },
  },
];
